import { LoadingOverlay } from "@mantine/core";

export const BaseLoadingOverlay = LoadingOverlay;
